import styled from '@emotion/styled'

/**
 * 재고 소진 딤 오버레이 — 랜딩 콘텐츠를 검정 85% 로 덮는다.
 * position: absolute (LandingContainer 기준) 라 헤더 영역은 덮지 않음 → 헤더(뒤로가기) 유지.
 * CTA 바(z-index 110)는 그 위에 노출.
 */
export const SoldOutOverlayContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 20px;
  background-color: rgba(0, 0, 0, 0.85);
`

/** "SOLD OUT" 알약 배지 */
export const SoldOutBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 9999px;
  background-color: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  font-weight: 600;
  line-height: 12px;
  letter-spacing: 0.48px;
`

export const SoldOutTitle = styled.p`
  margin: 0;
  white-space: pre-line;
  text-align: center;
  color: #ffffff;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.51px;
`
